export enum AxesType {
  DOUBLE = 'DOUBLE',
  TRIPLE = 'TRIPLE',
  EMPTY = ''
}
export enum TowingCapacity {
  IS_TOWING = 'IS_TOWING',
  IS_NOT_TOWING = 'IS_NOT_TOWING'
}
enum GoodsTypes {
  LIQUID = 'LIQUID',
  SOLID = 'SOLID',
  GAS = 'GAS',
  EMPTY = ''
}
export enum ContTypes {
  CONT_20DC = 'CONT_20DC',
  CONT_40DC = 'CONT_40DC'
}
export interface IRemoocCategory {
  name: String
  type: Number | undefined
  wheelNumber: Number | undefined
  priceTires: Number | undefined
  depreciationTires: Number | undefined
  description: String
}
export interface IRemooc {
  name: String | string
  remoocType: String | string
  nameTypeRemooc: String | string
  licensePlate: String | string
  manufacture: String | string
  manufactureYear: Number | undefined
  manufactureAt: String | string
  buyingTime: Number | undefined
  load: Number | undefined
  length: Number | undefined
  towingCapacity: Array<string> | []
  weight: Number | undefined
  price: Number | undefined
  depreciation: Number | null
  sellingPrice: Number | null
  status: Number | undefined
  axes: String | string
  coveringContainerLevel: String | string
  isTowingContainer: Boolean | boolean
  vehicle: String | string
  vehicleName: String | string
  description: String | string
  goodsType: Array<string> | []
  remoocCategoryDetail?: any
}
const initRemoocCategory = {
  name: '',
  type: undefined,
  wheelNumber: undefined,
  priceTires: undefined,
  depreciationTires: undefined,
  depreciationPeriodRemooc: null,
  priceLiquidation: null,
  depreciationRate: null,
  description: ''
}
const initRemooc = {
  name: '',
  remoocType: '',
  nameTypeRemooc: '',
  licensePlate: '',
  manufacture: '',
  manufactureYear: undefined,
  manufactureAt: '',
  buyingTime: undefined,
  load: undefined,
  length: undefined,
  towingCapacity: [],
  weight: undefined,
  price: undefined,
  depreciation: null,
  sellingPrice: null,
  status: undefined,
  axes: '',
  coveringContainerLevel: '',
  isTowingContainer: false,
  vehicle: '',
  vehicleName: '',
  description: '',
  goodsType: ['']
}
export default {
  initRemooc,
  initRemoocCategory
}
